// extracted by mini-css-extract-plugin
module.exports = {"tagContainer":"index_tagContainer__Dfr3i","tagText":"index_tagText__ZlRTK","icon":"index_icon__geo3G"};